<!-- eslint-disable -->
<template>
    <div class="contenu">
        <h1 class="titre">{{ $t('2024') }}</h1>

        <div class="section">
            <h2>{{ $t('2024Edition.registration') }}</h2>

            <p class="message">{{ $t('2024Edition.registrationMessage') }} <a href="mailto:info@supermileagequebec.com">info@supermileagequebec.com</a>.</p>

            <div class="container mt-5" style="margin-left: 10%;">
                <table class="table table-striped" style="width: 80%;">
                    <thead>
                        <tr style="font-family: Lato; font-size: 1.5em; text-align: left;">
                            <th>{{ $t('2024Edition.Table.subject') }}</th>
                            <th>{{ $t('2024Edition.Table.from') }}</th>
                            <th>{{ $t('2024Edition.Table.to') }}</th>
                        </tr>
                    </thead>
                    <tbody style="font-family: Lato; text-align: left;">
                        <tr v-for="item in tableData" :key="item.subject">
                            <td>{{ item.subject }}</td>
                            <td>{{ item.from }}</td>
                            <td>{{ item.to }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <h3 style="margin-top: 55px;">{{ $t('2024Edition.registrationFees') }}</h3>
            <p class="fees"><strong>{{ $t('2024Edition.carRegistration') }}</strong>{{ $t('2024Edition.carRegistrationFee') }}*</p>
            <p class="fees"><strong>{{ $t('2024Edition.memberRegistration') }}</strong>{{ $t('2024Edition.memberRegistrationFee') }}*</p>

            <p class="message" style="margin-top: 25px !important;">*{{ $t('2024Edition.sponsors') }}</p>

            <h3 style="margin-top: 90px; text-align: center;">{{ $t('2024Edition.fill') }}<a href="https://forms.gle/9twpXR3wFeZvVYv87" target="_blank" rel="noopener noreferrer">{{ $t('2024Edition.googleForms') }}</a></h3>
            <p class="message" style="margin-top: 25px !important; color: red; text-align: center !important;">{{ $t('2024Edition.limit') }}</p>
        </div>
        <div class="border" style="width:60%; align-content: center; margin: 20px auto;"></div>

        <div class="section">
            <h2>{{ $t('2024Edition.docs') }}</h2>

            <p class="message" style="margin: 25px 0 0 5% !important;"><a :href="rulesLink" target="_blank">{{ $t('2024Edition.rulesP1') }}</a></p>
            <p class="message" style="margin: 25px 0 0 5% !important;"><a :href="caseStudyLink" target="_blank">{{ $t('2024Edition.caseStudy') }}</a></p>
            <div style="margin-left: 5%;">
                <p class="message" style="margin: 15px 0 0 5% !important;"><a :href="csvCaseStudyLink" target="_blank">{{ $t('2024Edition.csvCaseStudy') }}</a></p>
                <p class="message" style="margin: 15px 0 0 5% !important;"><a :href="kmzCaseStudyLink" target="_blank">{{ $t('2024Edition.kmzCaseStudy') }}</a></p>
            </div>
        </div>

        <div class="border" style="width:60%; align-content: center; margin: 20px auto;"></div>

        <div class="section">
            <h2>{{ $t('2024Edition.accommodation') }}</h2>
            <div class="contenuAccommodation">
                <div class="textAccommodation">
                    <p class="message">{{ $t('2024Edition.unfolding') }}</p>

                    <p class="message" style="margin: 15px 0 0 5% !important;">- {{ $t('2024Edition.camping') }}</p>
                    <p class="message" style="margin: 5px 0 0 5% !important;">- {{ $t('2024Edition.food') }}</p>
                    <p class="message" style="margin: 5px 0 0 5% !important;">- {{ $t('2024Edition.hotels') }}</p>
                    <p class="message" style="margin: 5px 0 0 10% !important;">- <a href="https://maps.app.goo.gl/TBwd65htSfusy7SC9" target="_blank" rel="noopener noreferrer">Motel Royalco</a></p>
                    <p class="message" style="margin: 5px 0 0 10% !important;">- <a href="https://maps.app.goo.gl/chfddHbSUcqsom5e6" target="_blank" rel="noopener noreferrer">Econo Lodge Inn & Suites</a></p>
                </div>
                <div class="mapRiverside">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1429087.2662844735!2d-72.9846069409096!3d45.606904695594714!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cc77f49cff8db3f%3A0xc2b678546ee65d52!2sCircuit%20Ste-Croix%20Riverside%20Speedway!5e0!3m2!1sfr!2sca!4v1698378965203!5m2!1sfr!2sca" height="350" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        tableData() {
            return [
                { subject: this.$i18n.t('2024Edition.Table.registrationP1'), from: this.$i18n.t('2024Edition.Table.registrationP1From'), to: this.$i18n.t('2024Edition.Table.registrationP1To') },
                { subject: this.$i18n.t('2024Edition.Table.rulesP1'), from: this.$i18n.t('2024Edition.Table.rulesP1From'), to: '' },
                { subject: this.$i18n.t('2024Edition.Table.TCS'), from: this.$i18n.t('2024Edition.Table.TCSFrom'), to: this.$i18n.t('2024Edition.Table.TCSTo') },
                { subject: this.$i18n.t('2024Edition.Table.rulesP2'), from: this.$i18n.t('2024Edition.Table.rulesP2From'), to: '' },
                { subject: this.$i18n.t('2024Edition.Table.registrationP2'), from: this.$i18n.t('2024Edition.Table.registrationP2From'), to: this.$i18n.t('2024Edition.Table.registrationP2To') },
                { subject: this.$i18n.t('2024Edition.Table.feePayment'), from: this.$i18n.t('2024Edition.Table.feePaymentFrom'), to: this.$i18n.t('2024Edition.Table.feePaymentTo') },
                { subject: this.$i18n.t('2024Edition.Table.waiver'), from: this.$i18n.t('2024Edition.Table.waiverFrom'), to: this.$i18n.t('2024Edition.Table.waiverTo') },
                { subject: this.$i18n.t('2024Edition.Table.DPD'), from: this.$i18n.t('2024Edition.Table.DPDFrom'), to: '' },
            ];
        }
    },
    data() {
        return{
            rulesLink: '/CSQ24_Rule_Phase_I.pdf',
            caseStudyLink: '/CSQ24_Technical_Case_Study.pdf',
            csvCaseStudyLink: '/CSQ24_Endurance_Race_Data.csv',
            kmzCaseStudyLink: '/CSQ24_Endurance_Race_Data.kmz'
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1{
    width : auto;
    text-align: center;
    font-size : 2.5em;
}
h2{
    font-weight:600;
    text-align: left;
    font-family: Lato;
}
h3{
    font-weight:400;
    text-align: left;
    font-family: Lato;
}
p{
    margin-top: 25px;
    font-family: Lato;
    font-size: 1.2em;
}
th{
    background-color: #5fbf00b2 !important;
}
.titre{
    font-family: Rubik bold;
    letter-spacing: 0.1em;
    color: #193300; 
}
.contenu {
    width: 100%;
    margin-top : 75px;
}

.section{
    width: 75%;
    margin: 100px auto;
}
.message {
    text-align : left;
    font-size : 1.25em;
    font-family: Lato;
    margin: 55px 0 0 auto;
}
.fees {
    text-align: left;
    margin: 25px 0 0 5%;
    font-size: 1.25em;
}
.contenuAccommodation{
    display: flex;
}
.texteAccommodation{
    float: left;
    flex: 2;
}
.mapRiverside{
    margin-top: 50px;
    flex: 1;
}
.mapRiverside iframe{
    width: 450px;
}

@media (max-width: 1160px) {
    .contenuAccommodation{
        flex-direction: column;
    }
    .texteAccommodation{
        flex: none;
    }
    .mapRiverside{
        flex: none !important;
    }

}
@media (max-width: 750px) {
    .mapRiverside iframe{
        width: 300px;
    }
}
</style>
